<div class="form-search">
    <div class="pt-12 pb-4 px-16">
        <div class="secondary-text font-size-10 pl-4 pb-4"><b>{{title}}</b> <small class="ml-8" *ngIf="working">Carregando...</small></div>
        <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="start center" fxLayoutGap="16px" (keydown)="keyDownFunction($event)">
            <ng-content></ng-content>
        </div>
    </div>
</div> 